module.exports = __webpack_public_path__ + "53c37359bd9dd7d4c3253041e6cb2a53.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1039
// module chunks = 0